import React from 'react'
import { FacetFilterGroup } from 'types/form'
import LocalizedSelectArrayInput from 'ui-shared/LocalizedFields/LocalizedSelectArrayInput'
import { FacetSelectComponentProps, MultiSelectableFacetsCategory } from '..'
import useFacets from './useFacets'

type MultiPickListFacetCategory = MultiSelectableFacetsCategory
type MultiPickListFilterGroup = Extract<
  FacetFilterGroup,
  'Setting' | 'EventType' | 'Language'
>

type Props = FacetSelectComponentProps<
  MultiPickListFacetCategory,
  MultiPickListFilterGroup
>

const FacetMultiSelect: React.FC<Props> = ({
  facetCategory,
  source,
  filterGroup,
}) => {
  const facets = useFacets(facetCategory, filterGroup)
  if (!facets.length) return null

  return (
    <LocalizedSelectArrayInput
      label={`form.fields.${source}`}
      optionText="description"
      fullWidth
      source={source}
      choices={facets}
    />
  )
}

export default FacetMultiSelect
